import React from "react"
import BaseTextInput from "../../../../anwendungskonfigurator/content/widgets/BaseTextInput"
import RegularNumberFormatter from "../../../../anwendungskonfigurator/content/widgets/RegularNumberFormatter"
import {validateFloatingChars} from "../../../../anwendungskonfigurator/content/widgets/bloom-utils/validations"
import {deToNumberString} from "../../../../anwendungskonfigurator/content/widgets/bloom-utils/transformations"
import {deNumberStringToNumber} from "../../../../anwendungskonfigurator/misc/utils"

const percentProps = {
    onChangeValidations: [validateFloatingChars],
    endAdornment: "‰",
    inputProps: {
        decimalScale: 4,
        fixedDecimalScale: true,
        inputMode: "decimal",
    },
    inputComponent: RegularNumberFormatter,
}

const PromillieWithFourDecimal = props => {
    const onValueChange = value => {
        props.onValueChange(deNumberStringToNumber(value))
    }

    return (
        <BaseTextInput
            {...props}
            {...percentProps}
            onValueChange={onValueChange}
        />
    )
}

export default PromillieWithFourDecimal
